<template lang="pug">
.fpui-store.fpui-packages-store.row.full-height(:class="{'modal-mode':modal}")
  .store-content(v-if='!loading')
    .fpui-packages-store-list(v-if='!detail')
      fpui-categories.col-xs-3(
        title='assistant.store.categories.title'
        :categories='categories'
        v-model="category"
      )
      fpui-list-items.col-xs-9.right-side(
        :items="items",
        :category="category"
        :type='type'
        :consumer='consumer'
        @select='onSelectItem'
        @buy='$emit("buy", $event)'
        @install='$emit("install", $event)'
        @remove='onRemove'
        @edit='$emit("edit", $event)'
        @detail='detail = $event'
        @editStore='editStore'
        @create='createPackage'
      )
    fpui-package-detail(
      @close='closeDetail'
      :item='detail'
      @buy='$emit("buy", $event)'
      @install='$emit("install", $event)'
      @remove='onRemove'
      @edit='$emit("edit", $event)'
      @version='$emit("version", $event)'
      v-else
    )
  fp-loader(v-else)
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'

  import FpuiCategories from './FpuiCategories'
  import FpuiListItems from './FpuiListItems'
  import FpuiPackageDetail from './detail'
  import Categories from './categories.json'

  export default {
    name: 'FpuiStorePackages',
    components: { FpuiCategories, FpuiListItems, FpuiPackageDetail },
    props: {
      consumer: String,
      type: String,
      selection: { type: Object },
      modal: { type: Boolean, default: false }
    },
    data () {
      return {
        activeCategory: 'all',
        detail: null,
        unsubscribe: null,
        organizations: []
      }
    },
    computed: {
      categories () {
        let categories = cloneDeep(Categories)
        if (!this.installed) {
          delete categories.installed
          delete categories.notinstalled
          this.items.forEach(item => this.addToCategories(item, categories))
        } else {
          Object.keys(this.installed).forEach(key => {
            let item = this.items.find(item => item.id === key)
            this.addToCategories(item, categories)
          })
        }
        if (categories[this.activeCategory]) {
          categories[this.activeCategory].selected = true
        }
        return categories
      },
      category: {
        get () { return this.categories[this.activeCategory] },
        set (key) { this.activeCategory = key }
      },
      installed () { return this.$store.state.packages.installed },
      items () {
        return this.$store.getters.PACKAGES_BY_CONSUMER_TYPE(this.consumer, this.type).filter(item => {
          if (!this.$route.query.organization_id) return item.owner === 'forepaas' || this.organizations.includes(item.owner)
          return item.owner === 'forepaas' || item.owner === this.$route.query.organization_id
        })
      },
      loading () { return this.$store.getters.PACKAGES_LOADING }
    },
    async mounted () {
      this.init()
      this.unsubscribe = this.$store.subscribe(payload => {
        // This is to reset detail on uninstall/install package
        if (payload.type === 'PACKAGES_SET_INSTALLED' && this.detail) {
          this.detail = this.items.find(item => item.id === this.detail.id)
        }
      })

      // Get organizations to display only packages from organizations of user
      const organizations = await this.$api.king.organizations()
      this.organizations.splice(0, this.organizations.length)
      organizations.forEach(orga => {
        this.organizations.push(orga.id)
      })
    },
    destroyed () { this.unsubscribe() },
    methods: {
      addToCategories (item, categories) {
        const itemCategories = Array.isArray(item.category) ? item.category : [item.category]
        itemCategories.forEach(categ => {
          if (item && item.category && !categories[categ.toLowerCase()]) {
            categories[categ.toLowerCase()] = {
              name: categ,
              value: categ
            }
          }
        })
      },
      onSelectItem (item) { this.$emit('select', item) },
      init () {
        if (this.items.length === 0) return setTimeout(this.init, 100)
        this.items.forEach(item => {
          if (item.category && !this.categories[item.category]) {
            const itemCategories = Array.isArray(item.category) ? item.category : [item.category]
            itemCategories.forEach(categ => {
              this.$set(this.categories, categ, {
                name: categ.charAt(0).toUpperCase() + categ.slice(1),
                value: categ,
                selected: false
              })
            })
          }
        })
      },
      createPackage () { this.$router.push(`/packages/editor/${this.consumer}/${this.type}`) },
      editStore (item) { this.$router.push(`/packages/editor/${this.consumer}/${this.type}/${item.id}`) },
      onRemove (item) {
        if (!item.deprecated) {
          this.$emit('remove', item)
        }
      },
      closeDetail () {
        this.$emit('closeDetail', this.detail)
        this.detail = false
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

@maxHeightModal: 340px;

.fpui-packages-store {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  margin: 0;
  overflow: auto;

  .right-side {
    overflow: hidden;
  }

  &.modal-mode {
    .filter-by-category .list-group,
    .right-side .items {
      max-height: @maxHeightModal;
    }
  }
}

</style>
